module.exports = __webpack_public_path__ + "assets/img/uairango.5203a9e0.svg";